export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13275.7bcf4907.jpg";